<h1 class="sr-only">ePRINTit - Secure Cloud Solution</h1>
<router-outlet></router-outlet>
<app-cookies-disclaimer></app-cookies-disclaimer>
<app-help-widget></app-help-widget>
